import useAssets from '@web/common/src/composable/useAssets';
import classNames from 'classnames';
import './index.less';

export function Spinner() {
  const assets = useAssets(false);
  const name = import.meta.env.VITE_APP_NAME;
  return (
    <div className={classNames('spinner')}>
      {name === 'kaka' && <img className="w-120px mt-150px" src={assets.loading_hyaline} alt="" />}
    </div>
  );
}

// import classNames from 'classnames';
// import Lottie, { LottieRefCurrentProps } from 'lottie-react';
// import { useEffect, useRef } from 'react';
// import './index.less';
// import LoadingData from './loading.json';

// export function Spinner() {
//   const lottieRef = useRef<LottieRefCurrentProps>(null);
//   useEffect(() => {
//     lottieRef.current?.setSpeed(2.8);
//   }, []);
//   const name = import.meta.env.VITE_APP_NAME;
//   return (
//     <div className={classNames('spinner')}>
//       {name === 'kaka' && (
//         <div>
//           <Lottie
//             lottieRef={lottieRef}
//             className={classNames('spinner-img')}
//             animationData={LoadingData}
//           />
//           <p className={classNames('spinner-tips')}>正在努力加载中，请稍后…</p>
//         </div>
//       )}
//     </div>
//   );
// }
